import { CloudRenderingRegion } from "@/hooks/types";

export function sortRegions(a: CloudRenderingRegion, b: CloudRenderingRegion) {
  // If both have distance, sort by distance
  if (a.distanceM !== null && b.distanceM !== null) {
    return a.distanceM - b.distanceM;
  }
  // If only a has distance, it comes first
  if (a.distanceM !== null) return -1;
  // If only b has distance, it comes first
  if (b.distanceM !== null) return 1;
  // Both null, maintain order
  return 0;
}
